module.exports = __webpack_public_path__ + "media/images/front/banner_cc_top-18b14fea27a7553a8ae8b806a361df61.jpg";